
import React, { useState } from 'react';
import styles from './EnterpriseOptions.module.css';
import api from '../../services/api';

function EnterpriseOptions() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    group_name: '',
    message: ''
  });

  const [isSending, setIsSending] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);
    
    try {
      await api.post('/api/enterprise-contact', formData);
      alert('Message sent successfully!');
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        group_name: '',
        message: ''
      });
    } catch (error) {
      console.error('Error sending email:', error);
      alert('Failed to send message. Please try again later.');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.leftSection}>
          <h1>Get in touch</h1>
          <p>
            Connect with us to explore how our sophisticated betting tools can enhance your community's 
            experience and drive engagement through automation.
          </p>

          <div className={styles.contactInfo}>
            <div className={styles.infoItem}>
              <i className="fas fa-map-marker-alt"></i>
              <span>Perth, Australia</span>
            </div>

            <div className={styles.infoItem}>
              <i className="fas fa-envelope"></i>
              <span>booksbashers@gmail.com</span>
            </div>
          </div>
        </div>

        <form className={styles.rightSection} onSubmit={handleSubmit}>
          <div className={styles.nameFields}>
            <div className={styles.inputGroup}>
              <label>First name</label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>
            <div className={styles.inputGroup}>
              <label>Last name</label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className={styles.inputGroup}>
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className={styles.inputGroup}>
            <label>Group Name</label>
            <input
              type="text"
              name="group_name"
              value={formData.group_name}
              onChange={handleChange}
              required
            />
          </div>

          <div className={styles.inputGroup}>
            <label>Message</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className={styles.submitButton} disabled={isSending}>
            {isSending ? 'Sending...' : 'Send message'}
          </button>
        </form>
      </div>
    </>
  );
}

export default EnterpriseOptions;
